import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { Database, Users, Calendar, Building2, DollarSign, TrendingUp, Lightbulb, Rocket } from 'lucide-react';

export function Layout() {
  return (
    <div className="min-h-screen bg-gray-100">
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <NavLink
                to="/projects"
                className={({ isActive }) =>
                  `inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${
                    isActive
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
                }
              >
                <Database className="w-5 h-5 mr-2" />
                Projects
              </NavLink>

              <NavLink
                to="/customers"
                className={({ isActive }) =>
                  `inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${
                    isActive
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
                }
              >
                <Building2 className="w-5 h-5 mr-2" />
                Customers
              </NavLink>

              <NavLink
                to="/staff"
                className={({ isActive }) =>
                  `inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${
                    isActive
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
                }
              >
                <Users className="w-5 h-5 mr-2" />
                Team
              </NavLink>

              <NavLink
                to="/timeline"
                className={({ isActive }) =>
                  `inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${
                    isActive
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
                }
              >
                <Calendar className="w-5 h-5 mr-2" />
                Timeline
              </NavLink>

              <NavLink
                to="/calendar"
                className={({ isActive }) =>
                  `inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${
                    isActive
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
                }
              >
                <Calendar className="w-5 h-5 mr-2" />
                Calendar
              </NavLink>

              <NavLink
                to="/finance"
                className={({ isActive }) =>
                  `inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${
                    isActive
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
                }
              >
                <DollarSign className="w-5 h-5 mr-2" />
                Finance
              </NavLink>

              <NavLink
                to="/sales"
                className={({ isActive }) =>
                  `inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${
                    isActive
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
                }
              >
                <TrendingUp className="w-5 h-5 mr-2" />
                Sales
              </NavLink>

              <NavLink
                to="/ip"
                className={({ isActive }) =>
                  `inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${
                    isActive
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
                }
              >
                <Lightbulb className="w-5 h-5 mr-2" />
                IP
              </NavLink>

              <NavLink
                to="/spinoffs"
                className={({ isActive }) =>
                  `inline-flex items-center px-4 py-2 border-b-2 text-sm font-medium ${
                    isActive
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
                }
              >
                <Rocket className="w-5 h-5 mr-2" />
                Spin-offs
              </NavLink>
            </div>
          </div>
        </div>
      </nav>

      <main>
        <Outlet />
      </main>
    </div>
  );
}